/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/consistent-type-assertions */

import axios, { AxiosResponse } from 'axios'

import { iStorageApi } from './browser-store'
import {
  CANT_RECOVER_CODE_VERIFIER,
  INNER_STORE,
  PARAMS,
  STATE_NOT_EQUAL,
  STORE,
} from './constants'
import { put } from './inner-store'
import { interceptor } from './interceptor'
import { refreshOnTime } from './refresh-on-time'
import { iAuthResponse } from './types'
import { urlUtils } from './utils'

export interface iRedirectedConfig {
  browserStore: iStorageApi
  redirect_uri?: string
  client_id: string
  scope?: string
  authServerTokenUri: string
  autoRefresh: boolean
}
const redirected = async ({
  browserStore,
  redirect_uri,
  client_id,
  scope,
  authServerTokenUri,
  autoRefresh,
}: iRedirectedConfig): Promise<iAuthResponse> => {
  // recupera los datos guardados en el navegador
  const code_verifier = browserStore.getFromStore(STORE.code_verifier)
  const state = browserStore.getFromStore(STORE.state)

  // limpiar los valores PKCE del storage después de leerlos
  browserStore.deleteFromStore(STORE.code_verifier)
  browserStore.deleteFromStore(STORE.state)

  console.log('code_verifier', code_verifier)
  console.log('state', state)

  // recupera los datos de la URL
  const authorization_code = urlUtils.getQueryParam(PARAMS.code)
  const redirectState = urlUtils.getQueryParam(PARAMS.state)

  urlUtils.clearParams([
    PARAMS.code,
    PARAMS.state,
    PARAMS.sessionState,
  ])

  if (code_verifier === null) {
    throw new Error(CANT_RECOVER_CODE_VERIFIER)
  }
  if (state !== redirectState) throw new Error(STATE_NOT_EQUAL)
  const body = {
    grant_type: 'authorization_code',
    code: authorization_code,
    client_id,
    code_verifier,
    ...(redirect_uri !== undefined
      ? { redirect_uri }
      : { redirect_uri: window.location.href }),
    ...(scope !== undefined ? { scope } : undefined),
  } as Record<string, string>

  const { data } = await axios.request<
    typeof body,
    AxiosResponse<iAuthResponse>
  >({
    url: authServerTokenUri,
    method: 'post',
    data: new URLSearchParams(body).toString(),
  })

  put(INNER_STORE.auth, { ...data, isAuthenticated: true })
  interceptor()

  if (autoRefresh) refreshOnTime()

  return data
}

export { redirected }
